





















































import { Component, Mixins } from "vue-property-decorator";
import ClaioImageThumbnail from "./claio/ClaioImageThumbnail.vue";
import ClaioImageFinder from "./claio/ClaioImageFinder.vue";
import ClaioImageSizeSelector from "./claio/ClaioImageSizeSelector.vue";
import ClaioImagePreviewSizeSelector from "./claio/ClaioImagePreviewSizeSelector.vue";
import ClaioImagePreview from "./claio/ClaioImagePreview.vue";
import { ClaioContentsToolMixin } from "./mixins";

@Component({
  components: {
    ClaioImageThumbnail,
    ClaioImageFinder,
    ClaioImageSizeSelector,
    ClaioImagePreviewSizeSelector,
    ClaioImagePreview,
  }
})
export default class ClaioContentsTool extends Mixins(ClaioContentsToolMixin) {
}
